export enum FilePurpose {
  PRODUCTS = "PRODUCTS",
  ORGANIZATIONS = "ORGANIZATIONS",
  OFFERS = "OFFERS",
}

export interface FilesInput {
  purpose: FilePurpose;
}

export interface FilesOutput extends FilesInput {
  type: string;
  id: string;
  url: string;
  organization_id: string;
}
